import { useCallback, useEffect } from "react";
import { isParticipantInactive } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Participant } from "@circle-react/types/Live/Participant";
import { useLeaveRoom } from "./useLeaveRoom";

export const useComponentCloseListener = (
  isConnected: boolean,
  currentParticipant: Participant | null,
) => {
  const leaveRoom = useLeaveRoom();

  const handleLeaveRoom = useCallback(() => {
    void leaveRoom();
  }, [leaveRoom]);

  useEffect(() => {
    if (
      !isConnected ||
      !currentParticipant ||
      isParticipantInactive(currentParticipant)
    ) {
      return;
    }

    // 100ms recommended window events
    window.addEventListener("beforeunload", handleLeaveRoom);
    window.addEventListener("unload", handleLeaveRoom);

    return () => {
      window.removeEventListener("beforeunload", handleLeaveRoom);
      window.removeEventListener("unload", handleLeaveRoom);
    };
  }, [isConnected, currentParticipant?.id, handleLeaveRoom]);

  // Leave when component is unmounting
  useEffect(() => {
    if (!currentParticipant || isParticipantInactive(currentParticipant)) {
      return;
    }

    return () => {
      if (currentParticipant && !isParticipantInactive(currentParticipant)) {
        handleLeaveRoom();
      }
    };
  }, [currentParticipant?.id]);
};
